import { useState } from "react";
import { CTA } from "@merchstores/shared/elements/Cta";
import { IMerchStore } from "@merchstores/admin/components/MerchStore";

import { buildCheckoutFields, combineOrdersItems, requestCheckoutUrl } from "@merchstores/admin/components/MerchStoreOrderCheckout";
import { fetchIndividualOrders, ICombinedOrder } from "@merchstores/admin/components/MerchStoreOrders";

export interface IOrderCheckoutCTAProps {
    display?: boolean,
    merchStore: IMerchStore,
    combinedOrder: ICombinedOrder
}

export const OrderCheckoutCTA : React.FC<IOrderCheckoutCTAProps> = (props: IOrderCheckoutCTAProps) => {
  const [waitForSubmit, setWaitForSubmit] = useState(false);
  const merchStore = props.merchStore;
  const combinedOrder = props.combinedOrder;

  const handleProceedToCheckout = async () =>
  {
    setWaitForSubmit(true);
    
    const individualOrdersData = await fetchIndividualOrders(merchStore.storeCode, combinedOrder.id);
    const individualOrders = individualOrdersData.orders;
    const orderItems = await combineOrdersItems(merchStore, individualOrders);

    const checkoutFields = buildCheckoutFields(orderItems, merchStore);

    try {
      const checkoutResponse = await requestCheckoutUrl(checkoutFields);
      
      if (checkoutResponse.checkoutUrl)
      {
        window.location.assign(checkoutResponse.checkoutUrl);
      }
    }
    catch (err)
    {
      console.error(err);
    }

    setWaitForSubmit(false)
  }

  if (props.display === false)
  {
    return null;
  }

  return (
    <div className="cart-checkout-cta w-full">
      <CTA 
        type="primary" 
        size="standard" 
        classes="text-sm w-full" 
        onClick={handleProceedToCheckout}
        disabled={waitForSubmit}>
        { waitForSubmit ? "Loading..." : "Submit Order" }
      </CTA>
    </div>
  )
}